import type { ReactNode } from "react";
import { BrandColors } from "@repo/design-tokens";

export function GoogleIcon(): ReactNode {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" className="size-5 shrink-0">
      <path
        fill={BrandColors.google.blue}
        d="M21.6 12.23c0-.71-.06-1.4-.18-2.07H12v3.92h5.38a4.6 4.6 0 0 1-2 3.02v2.54h3.24c1.9-1.75 2.98-4.33 2.98-7.41Z"
      />
      <path
        fill={BrandColors.google.green}
        d="M12 22c2.7 0 4.98-.9 6.63-2.36l-3.24-2.54c-.9.6-2.05.96-3.39.96-2.61 0-4.82-1.76-5.61-4.13H3.04v2.62A10 10 0 0 0 12 22Z"
      />
      <path
        fill={BrandColors.google.yellow}
        d="M6.39 13.93A6 6 0 0 1 6.08 12c0-.67.11-1.32.31-1.93V7.45H3.04A10 10 0 0 0 2 12c0 1.64.39 3.19 1.04 4.55l3.35-2.62Z"
      />
      <path
        fill={BrandColors.google.red}
        d="M12 5.94c1.47 0 2.79.5 3.82 1.5l2.88-2.88A9.64 9.64 0 0 0 12 2a10 10 0 0 0-8.96 5.45l3.35 2.62C7.18 7.7 9.39 5.94 12 5.94Z"
      />
    </svg>
  );
}

export function AppleIcon(): ReactNode {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="size-5 shrink-0 fill-current"
    >
      <path d="M17.05 12.54c-.03-3.03 2.47-4.5 2.58-4.57a5.54 5.54 0 0 0-4.36-2.36c-1.83-.19-3.61 1.1-4.54 1.1-.95 0-2.38-1.08-3.93-1.05a5.78 5.78 0 0 0-4.86 2.97c-2.11 3.65-.54 9.02 1.48 11.97 1.01 1.45 2.18 3.06 3.73 3 1.51-.06 2.08-.96 3.91-.96 1.81 0 2.35.96 3.92.93 1.63-.03 2.66-1.45 3.63-2.91a11.9 11.9 0 0 0 1.66-3.38 5.22 5.22 0 0 1-3.22-4.74ZM14.08 3.67A5.3 5.3 0 0 0 15.29 0a5.4 5.4 0 0 0-3.49 1.74 5.05 5.05 0 0 0-1.24 3.53 4.46 4.46 0 0 0 3.52-1.6Z" />
    </svg>
  );
}
